import { merge as v, minus as I, traverseWithCb as O, TRAVERSE_COMMAND as N, isExpilicitlyNotLoaded as P } from "./ghl-ui.es1141.js";
class R extends Error {
  constructor() {
    super(), this.message = "SubtreeNotLoadedError: checking a subtree whose required nodes are not fully loaded.";
  }
}
function U(r, s, e, n) {
  return m(s.concat(r), e, n, !1);
}
function D(r, s) {
  const e = /* @__PURE__ */ new Set();
  return r.forEach((n) => {
    const d = s.treeNodeMap.get(n);
    if (d !== void 0) {
      let t = d.parent;
      for (; t !== null && !(t.disabled || e.has(t.key)); )
        e.add(t.key), t = t.parent;
    }
  }), e;
}
function q(r, s, e, n) {
  const d = m(s, e, n, !1), t = m(r, e, n, !0), f = D(r, e), l = [];
  return d.forEach((o) => {
    (t.has(o) || f.has(o)) && l.push(o);
  }), l.forEach((o) => d.delete(o)), d;
}
function V(r, s) {
  const { checkedKeys: e, keysToCheck: n, keysToUncheck: d, indeterminateKeys: t, cascade: f, leafOnly: l, checkStrategy: o, allowNotLoaded: h } = r;
  if (!f)
    return n !== void 0 ? {
      checkedKeys: v(e, n),
      indeterminateKeys: Array.from(t)
    } : d !== void 0 ? {
      checkedKeys: I(e, d),
      indeterminateKeys: Array.from(t)
    } : {
      checkedKeys: Array.from(e),
      indeterminateKeys: Array.from(t)
    };
  const { levelTreeNodeMap: y } = s;
  let a;
  d !== void 0 ? a = q(d, e, s, h) : n !== void 0 ? a = U(n, e, s, h) : a = m(e, s, h, !1);
  const T = o === "parent", E = o === "child" || l, i = a, b = /* @__PURE__ */ new Set(), x = Math.max.apply(null, Array.from(y.keys()));
  for (let k = x; k >= 0; k -= 1) {
    const w = k === 0, L = y.get(k);
    for (const u of L) {
      if (u.isLeaf)
        continue;
      const { key: S, shallowLoaded: p } = u;
      if (E && p && u.children.forEach((c) => {
        !c.disabled && !c.isLeaf && c.shallowLoaded && i.has(c.key) && i.delete(c.key);
      }), u.disabled || !p)
        continue;
      let C = !0, K = !1, g = !0;
      for (const c of u.children) {
        const A = c.key;
        if (!c.disabled) {
          if (g && (g = !1), i.has(A))
            K = !0;
          else if (b.has(A)) {
            K = !0, C = !1;
            break;
          } else if (C = !1, K)
            break;
        }
      }
      C && !g ? (T && u.children.forEach((c) => {
        !c.disabled && i.has(c.key) && i.delete(c.key);
      }), i.add(S)) : K && b.add(S), w && E && i.has(S) && i.delete(S);
    }
  }
  return {
    checkedKeys: Array.from(i),
    indeterminateKeys: Array.from(b)
  };
}
function m(r, s, e, n) {
  const { treeNodeMap: d, getChildren: t } = s, f = /* @__PURE__ */ new Set(), l = new Set(r);
  return r.forEach((o) => {
    const h = d.get(o);
    h !== void 0 && O(h, (y) => {
      if (y.disabled)
        return N.STOP;
      const { key: a } = y;
      if (!f.has(a) && (f.add(a), l.add(a), P(y.rawNode, t))) {
        if (n)
          return N.STOP;
        if (!e)
          throw new R();
      }
    });
  }), l;
}
export {
  R as SubtreeNotLoadedError,
  V as getCheckedKeys,
  m as getExtendedCheckedKeySet
};
